/**
 * Utility module to store and access handleOnSubmit function
 * without directly importing the useAndOrGrouping hook
 */

type HandleOnSubmitFunction = () => void;

let handleOnSubmitRef: HandleOnSubmitFunction | null = null;

/**
 * Register the handleOnSubmit function
 * This should be called from the hook to register the function
 */
export const registerHandleOnSubmit = (handler: HandleOnSubmitFunction) => {
  handleOnSubmitRef = handler;
};

/**
 * Unregister the handleOnSubmit function
 */
export const unregisterHandleOnSubmit = () => {
  handleOnSubmitRef = null;
};

/**
 * Call the registered handleOnSubmit function
 * Returns true if the function was called, false if no function was registered
 */
export const callHandleOnSubmit = (): boolean => {
  if (handleOnSubmitRef) {
    handleOnSubmitRef();
    return true;
  }

  return false;
};

/**
 * Check if handleOnSubmit is registered
 */
export const isHandleOnSubmitRegistered = (): boolean => {
  return handleOnSubmitRef !== null;
};

